<template>
<div class="workerContainer">
    <!-- <h3>משתמשים</h3> -->
    <div class="workerCard" v-for="(User,index) in Users" >
        <div class="imgDiv">
            <img class="profileImg" :src="User.profileImg" alt="">
        </div>
        <b class="profileName">{{ User.firstName + " " + User.lastName }}</b>
        <!-- <span class="profileRole">{{ User.Type }}</span> -->
        <span class="profileRole" v-show="User.Type == 'Manager'">מנהל</span>
        <span class="profileRole" v-show="User.Type == 'Worker'">עובד/ת</span>
        <span class="profileRole" v-show="User.Type == 'Admin'">מנהל המערכת</span>
        <div class="btnBox">
            <button>הגדרות הפרופיל</button>
        </div>
        <div class="btnBox">
            <button @click="logoutUser(User)">ניתוק משתמש</button>
        </div>
    </div>
</div>

</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import { db } from "../firebase";
import moment from 'moment';

export default{
  name: 'addWorkers',
  data () {
    return {
            Users:[],
            User:{
                fullName:'',
                username:'',
                password:'',
                Type:'',
                profileImg:'',
                active: false,
            }
        
        
    }
  },created(){
    let vm = this;
        if(vm.$root.loggedUser.Type == 'Worker'){
            vm.$router.push("/Home");
        }
        vm.loadWorkers();
    },
    methods:{
            addData(){
                let vm = this;
            if (vm.User.fullName.length > 0 ){
            
            db.collection("Users").add(vm.User)
                .then((WorkersResult) => {   
                    alert("משתמש חדש נוסף בהצלחה");
                    vm.User.fullName = "";
                    vm.User.username = "";
                    vm.User.password = "";
                    vm.User.Type = "";
                    console.log("Add ( WorkersResult ) Success");
                    console.log(WorkersResult);
                })
                .catch((error) => {
                    alert("שגיאה");
                    console.error('add( WorkersResult ) Error !');
                    console.error(error);
                });
                }
            },
            loadWorkers(){
                let vm = this;
                vm.Users = [];
                db.collection("Users").get().then((result) => {
                    console.log("Load Workers has been statred!");
                    for(let a = 0; a < result.size; a++){
                      let workerId = result.docs[a].id;
                      let User = result.docs[a].data();
                      // console.log(orderResult.size);
                      let resultcount = result.size;
                      console.log("Orders Count Is : " + result);
                      vm.Users.push({
                        ID: workerId,
                        firstName: User.firstName,
                        lastName: User.lastName,
                        username: User.username,
                        password: User.password,
                        Type: User.Type,
                        profileImg: User.profileImg
                        });
                    }

                }).catch((error)=>{
                    console.log("Error", error)
                })
            },
            logoutUser(User){
                let vm = this;
               
                    db.collection("Users").doc(User.ID).get()
                    .then((user) =>{
                        let userData = user.data();
                        userData.active = false;
                        db.collection("Users").doc(User.ID).update(userData);
                        console.log("New User Status is :" + userData.active) ;
                        // alert("הכמות במלאי עודכנה בהצלחה");
                    })
                    .catch((error) =>{
                        console.log("Error :" , error);
                    })
                
            },
    }

}</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap');

*{
    padding: 0;
    margin: 0;
	box-sizing: border-box;
}
.workerContainer{
    padding: 0 0.5rem;
    display: flex;
    JUSTIFY-CONTENT: center;
    height: 100%;

}
.workerCard{
    width: 200px;
    min-height: 200px;
    background-color: #fff;
    background-color: #FFF;
	border-radius: 10px;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    padding: 1rem 0;
    float: right;
    margin: 10px;
}
.imgDiv{
    width: 100%;
    display: flex;
    justify-content: center;
}
.profileImg{
    width: 100px;
    height: 100px;
    border-radius: 50%;
    border: 2px solid #1c1c1c;
    padding: 2px;
}
.profileName{
    display: block;
    text-align: center;
    margin-top: 10px ;
    color: #1c1c1c;
}
.profileRole{
    display: block;
    text-align: center;
    margin-bottom: 10px;
    color: #666;
    font-size: 14px;
    font-weight: 500;
}
.btnBox{
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
}
.btnBox button{
    padding: 5px 20px;
    border: 0;
    font-size: 14px;
    font-weight: 500;
    border-radius: 8px;
}


img {
	max-width: 100%;
	display: block;
}
input {
	appearance: none;
	border-radius: 0;
}

.card {
	margin: 2rem auto;
	display: flex;
	flex-direction: column;
	width: 100%;
	max-width: 425px;
	background-color: #FFF;
	border-radius: 10px;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;

	padding: .75rem;
}

.card-image {
	border-radius: 8px;
	overflow: hidden;
	padding-bottom: 65%;
	background-image: url('https://assets.codepen.io/285131/coffee_1.jpg');
	background-repeat: no-repeat;
	background-size: 150%;
	background-position: 0 5%;
	position: relative;
}

.card-heading {
	position: absolute;
	left: 10%;
	top: 15%;
	right: 10%;
	font-size: 1.75rem;
	font-weight: 700;
	color: #735400;
	line-height: 1.222;
}

.card-form {
	padding: 2rem 1rem 0;
}

.input {
	display: flex;
	flex-direction: column-reverse;
	position: relative;
	padding-top: 1.5rem;
	&+.input {
		margin-top: 1.5rem;
	}
}

.input-label {
	color: #8597a3;
	position: absolute;
	top: 1.5rem;
	transition: .25s ease;
}

.input-field {
	border: 0;
	z-index: 1;
	background-color: transparent;
	border-bottom: 2px solid #eee; 
	font: inherit;
	font-size: 14px;
	padding: .25rem 0;
	&:focus, &:valid {
		outline: 0;
		border-bottom-color: #00693E;
		&+.input-label {
			color: #00693E;
			transform: translateY(-1.5rem);
		}
	}
}
select {
	border: 0;
	z-index: 1;
	background-color: transparent;
	border-bottom: 2px solid #eee; 
	font: inherit;
	font-size: 14px;
	padding: .25rem 0;
	&:focus, &:valid {
		outline: 0;
		border-bottom-color: #00693E;
		&+.input-label {
			color: #00693E;
			transform: translateY(-1.5rem);
		}
	}
}
.action {
	margin-top: 2rem;
}

.action-button {
	font: inherit;
	font-size: 1.25rem;
	padding: 1em;
	width: 100%;
	font-weight: 500;
	background-color: #00693E;
	border-radius: 6px;
	color: #FFF;
	border: 0;
	&:focus {
		outline: 0;
	}
}

.card-info {
	padding: 1rem 1rem;
	text-align: center;
	font-size: .875rem;
	color: #8597a3;
	a {
		display: block;
		color: #6658d3;
		text-decoration: none;
	}
}





</style>



<!-- 	
	<div class="card">
		<div class="card-image">	
			<h2 class="card-heading">
				הוספת משתמש חדש
			</h2>
		</div>
		<div class="card-form">
			<div class="input">
				<input type="text" class="input-field" v-model="User.fullName"/>
				<label class="input-label">שם מלא</label>
			</div>
						<div class="input">
				<input type="text" class="input-field" v-model="User.username" />
				<label class="input-label">שם המשתמש</label>
			</div>
            <div class="input">
				<input type="password" class="input-field" v-model="User.password"/>
				<label class="input-label">סיסמה</label>
			</div>
            <div class="input">
				<select v-model="User.Type">
                    <option value="Manager">מנהל</option>
                    <option value="Worker">עובד</option>
                </select>
				<label class="input-label">תפקיד</label>
			</div>
			<div class="action">
				<button class="action-button" @click="addData()">הוספה</button>
                
			</div>
		</div>

	</div> -->


// WEBPACK FOOTER //
// src/pages/AddWorkers.vue